import AddPixel from './EcomPixel'
export default AddPixel
